document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-site-header]');
const mobileToggle = document.querySelector('[data-menu-toggle]');
const navOverlay = document.querySelector('[data-nav-overlay]');
const navCloseButtons = document.querySelectorAll('[data-nav-close]');
const navTriggers = document.querySelectorAll('[data-nav-trigger]');
const navItems = document.querySelectorAll('[data-nav-item]');
const searchTrigger = document.querySelector('[data-search-trigger]');
const searchInput = document.querySelector('#HeaderSearch');
const heroSection = document.querySelector('.hero, .journal-hero-slider');
const desktopMedia = window.matchMedia('(min-width: 981px)');
const contactPage = document.querySelector('.contact-page--hba');
const learningPortal = document.querySelector('.learning-portal');
let mobileTabLeaveTimer;
let mobileTabPreviewTimer;
let viewportMetricWidth = 0;

function syncViewportWidthMetric() {
  const clientWidth = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--auniverse-client-width', `${clientWidth}px`);

  if (!viewportMetricWidth || Math.abs(clientWidth - viewportMetricWidth) > 8) {
    viewportMetricWidth = clientWidth;
    document.documentElement.style.setProperty('--auniverse-viewport-height', `${window.innerHeight}px`);
  }
}

syncViewportWidthMetric();
window.addEventListener('resize', syncViewportWidthMetric);

function syncPanelControls(activePanel = null) {
  navTriggers.forEach((trigger) => {
    trigger.setAttribute('aria-expanded', String(trigger.dataset.panel === activePanel));
  });
  searchTrigger?.setAttribute('aria-expanded', String(activePanel === 'search'));
}

function setHeaderState() {
  if (!header) return;
  const wasCompact = header.classList.contains('is-compact');
  const pastHero = heroSection
    ? window.scrollY > heroSection.offsetTop + heroSection.offsetHeight - 80
    : window.scrollY > 28;
  const compact = header.classList.contains('is-compact')
    ? window.scrollY > 86
    : window.scrollY > 118;

  header.classList.toggle('is-scrolled', window.scrollY > 28);
  header.classList.toggle('is-past-hero', pastHero);
  header.classList.toggle('is-compact', compact);
  if (wasCompact && !compact && !desktopMedia.matches) {
    window.clearTimeout(mobileTabLeaveTimer);
    window.clearTimeout(mobileTabPreviewTimer);
    header.classList.add('is-tab-leaving');
    header.classList.remove('is-tab-expanded');
    mobileTabLeaveTimer = window.setTimeout(() => {
      header.classList.remove('is-tab-leaving');
    }, 280);
  }
  if (compact) {
    window.clearTimeout(mobileTabLeaveTimer);
    header.classList.remove('is-tab-leaving');
    if (!wasCompact && !desktopMedia.matches && !document.body.classList.contains('nav-open')) {
      window.clearTimeout(mobileTabPreviewTimer);
      header.classList.add('is-tab-expanded');
      mobileTabPreviewTimer = window.setTimeout(() => {
        header.classList.remove('is-tab-expanded');
      }, 2000);
    }
  }
  document.body.classList.toggle('offscreen', compact && !contactPage);
}

function activatePanel(panelName) {
  const isSubmenuPanel = Array.from(document.querySelectorAll('.nav-submenu')).some((panel) => (
    panel.dataset.panelContent === panelName
  ));
  const isSearchPanel = panelName === 'search';
  document.querySelectorAll('[data-panel-content]').forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.panelContent === panelName);
    if (panel.classList.contains('nav-submenu')) {
      panel.style.maxHeight = !desktopMedia.matches && panel.dataset.panelContent === panelName
        ? `${panel.scrollHeight}px`
        : '';
    }
  });
  navItems.forEach((item) => {
    const trigger = item.querySelector('[data-nav-trigger]');
    item.classList.toggle('is-active', trigger?.dataset.panel === panelName);
  });
  navTriggers.forEach((trigger) => {
    trigger.classList.toggle('is-active', trigger.dataset.panel === panelName);
  });
  syncPanelControls(panelName);
  document.body.classList.toggle('has-nav-panel', isSubmenuPanel);
  document.body.classList.toggle('has-search-panel', isSearchPanel);
}

function openDesktopNav(trigger, panelName) {
  window.clearTimeout(mobileTabPreviewTimer);
  navOverlay?.classList.add('is-open');
  mobileToggle?.setAttribute('aria-expanded', 'true');
  header?.classList.add('compact-menu-open');
  document.body.classList.add('nav-open');

  if (trigger && desktopMedia.matches) {
    document.body.offsetHeight;
    const left = trigger.getBoundingClientRect().left;
    document.documentElement.style.setProperty('--active-nav-position', `${left}px`);
  }
  if (panelName) activatePanel(panelName);
}

function closeDesktopNav() {
  window.clearTimeout(mobileTabPreviewTimer);
  navOverlay?.classList.remove('is-open');
  document.documentElement.style.setProperty('--active-nav-position', 'calc(100% + 135px)');
  document.querySelectorAll('[data-panel-content]').forEach((panel) => {
    panel.classList.remove('is-active');
    if (panel.classList.contains('nav-submenu')) panel.style.maxHeight = '';
  });
  navItems.forEach((item) => item.classList.remove('is-active'));
  syncPanelControls();
  mobileToggle?.setAttribute('aria-expanded', 'false');
  mobileToggle?.classList.remove('is-open');
  header?.classList.remove('compact-menu-open', 'is-tab-expanded');
  document.body.classList.remove('nav-open', 'has-nav-panel', 'has-search-panel');
}

function isPlainPrimaryClick(event) {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

header?.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link || !header.contains(link) || !isPlainPrimaryClick(event)) return;
  if (link.target && link.target.toLowerCase() !== '_self') return;

  closeDesktopNav();
});

window.addEventListener('pageshow', () => {
  closeDesktopNav();
  setHeaderState();
});

navTriggers.forEach((trigger) => {
  trigger.addEventListener('click', (event) => {
    event.preventDefault();

    if (!desktopMedia.matches) {
      const item = trigger.closest('[data-nav-item]');
      const panel = item?.querySelector('[data-panel-content]');
      if (!item || !panel) return;
      const isActive = item.classList.contains('is-active');
      navItems.forEach((navItem) => {
        navItem.classList.remove('is-active');
        navItem.querySelector('[data-nav-trigger]')?.setAttribute('aria-expanded', 'false');
        const submenu = navItem.querySelector('[data-panel-content]');
        if (submenu?.classList.contains('nav-submenu')) {
          submenu.style.maxHeight = '0px';
          if (submenu !== panel) {
            window.setTimeout(() => {
              if (!navItem.classList.contains('is-active')) {
                submenu.classList.remove('is-active');
              }
            }, 420);
          }
        }
      });
      if (!isActive) {
        item.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-active');
        panel.style.maxHeight = '0px';
        window.requestAnimationFrame(() => {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        });
      } else {
        window.setTimeout(() => {
          if (!item.classList.contains('is-active')) {
            panel.classList.remove('is-active');
          }
        }, 420);
      }
      return;
    }

    openDesktopNav(trigger, trigger.dataset.panel);
  });
});

searchTrigger?.addEventListener('click', () => {
  openDesktopNav(searchTrigger, 'search');
  window.setTimeout(() => searchInput?.focus(), 220);
});

navCloseButtons.forEach((button) => button.addEventListener('click', closeDesktopNav));
navOverlay?.addEventListener('click', closeDesktopNav);

function isCompactMobileTabHandleClick(event) {
  if (!mobileToggle || !header || desktopMedia.matches || !header.classList.contains('is-compact')) return false;
  const rect = mobileToggle.getBoundingClientRect();
  return event.clientX >= rect.left && event.clientX <= rect.left + 12;
}

if (mobileToggle) {
  mobileToggle.addEventListener('click', (event) => {
    if (document.body.classList.contains('nav-open')) {
      closeDesktopNav();
      return;
    }

    if (!desktopMedia.matches && header?.classList.contains('is-compact') && isCompactMobileTabHandleClick(event)) {
      event.preventDefault();
      window.clearTimeout(mobileTabPreviewTimer);
      header.classList.toggle('is-tab-expanded');
      return;
    }

    openDesktopNav(mobileToggle, null);
    mobileToggle.classList.add('is-open');
  });
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeDesktopNav();
  }
});

setHeaderState();
window.addEventListener('scroll', setHeaderState, { passive: true });

const revealItems = document.querySelectorAll('[data-reveal]');
const imageRevealItems = Array.from(document.querySelectorAll('[data-image-reveal]')).filter((item) => (
  !item.closest('[data-projects-archive]')
));

if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  revealItems.forEach((item) => revealObserver.observe(item));
  imageRevealItems.forEach((item) => revealObserver.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
  imageRevealItems.forEach((item) => item.classList.add('is-visible'));
}

const expertiseIntroMedia = document.querySelectorAll('.expertise-detail__intro-media[data-image-reveal]');
if (expertiseIntroMedia.length) {
  if ('IntersectionObserver' in window) {
    const expertiseIntroMediaObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          expertiseIntroMediaObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -18% 0px' });

    expertiseIntroMedia.forEach((item) => expertiseIntroMediaObserver.observe(item));
  } else {
    expertiseIntroMedia.forEach((item) => item.classList.add('is-visible'));
  }
}

const searchResultCards = document.querySelectorAll('.search-result-card');
if (searchResultCards.length) {
  const revealSearchCardImage = (card) => {
    card.querySelector('[data-image-reveal]')?.classList.add('is-visible');
  };

  if ('IntersectionObserver' in window) {
    const searchCardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealSearchCardImage(entry.target);
          searchCardObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -14% 0px' });

    searchResultCards.forEach((card) => searchCardObserver.observe(card));
  } else {
    searchResultCards.forEach(revealSearchCardImage);
  }
}

const projectsArchiveReveal = document.querySelector('[data-projects-archive]');
if (projectsArchiveReveal) {
  const revealProjectRow = (card) => {
    if (!card) return;
    const cards = Array.from(projectsArchiveReveal.querySelectorAll('[data-project-card]:not(.is-hidden)'));
    const rowTop = Math.round(card.getBoundingClientRect().top);
    cards.forEach((rowCard) => {
      const rect = rowCard.getBoundingClientRect();
      if (Math.abs(Math.round(rect.top) - rowTop) < 18) {
        rowCard.querySelector('.projects-card__media')?.classList.add('is-visible');
      }
    });
  };

  const projectCards = Array.from(projectsArchiveReveal.querySelectorAll('[data-project-card]'));
  window.requestAnimationFrame(() => revealProjectRow(projectCards.find((card) => !card.classList.contains('is-hidden'))));
  if ('IntersectionObserver' in window) {
    const projectRowObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealProjectRow(entry.target);
          projectRowObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -48% 0px' });

    const observeProjectRows = () => projectCards.forEach((card) => projectRowObserver.observe(card));
    if (window.scrollY > 24) {
      observeProjectRows();
    } else {
      window.addEventListener('scroll', observeProjectRows, { passive: true, once: true });
    }
  } else {
    projectCards.forEach((card) => revealProjectRow(card));
  }
}

const projectArticleImages = document.querySelectorAll('[data-project-image-reveal]');
if (projectArticleImages.length) {
  const revealArticleImageGroup = (image) => {
    const section = image.closest('section');
    const group = section
      ? Array.from(section.querySelectorAll('[data-project-image-reveal]'))
      : [image];
    group.forEach((item) => item.classList.add('is-visible'));
  };

  const checkArticleImages = () => {
    projectArticleImages.forEach((image) => {
      if (image.classList.contains('is-visible')) return;
      const rect = image.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.82 && rect.bottom > window.innerHeight * 0.08) {
        revealArticleImageGroup(image);
      }
    });
  };

  checkArticleImages();
  window.addEventListener('scroll', checkArticleImages, { passive: true });
  window.addEventListener('resize', checkArticleImages);
}

document.querySelectorAll('[data-project-image-pan]').forEach((frame) => {
  const image = frame.querySelector('img');
  if (!image) return;

  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let startPositionX = 50;
  let startPositionY = 50;
  let positionX = 50;
  let positionY = 50;

  const setImagePosition = () => {
    image.style.objectPosition = `${positionX}% ${positionY}%`;
  };

  const clampPosition = (value) => clamp(value, 0, 100);

  frame.addEventListener('pointerdown', (event) => {
    if (!window.matchMedia('(max-width: 900px)').matches) return;
    isDragging = true;
    startX = event.clientX;
    startY = event.clientY;
    startPositionX = positionX;
    startPositionY = positionY;
    frame.classList.add('is-panning');
    frame.setPointerCapture?.(event.pointerId);
  });

  frame.addEventListener('pointermove', (event) => {
    if (!isDragging) return;
    const rect = frame.getBoundingClientRect();
    const deltaX = event.clientX - startX;
    const deltaY = event.clientY - startY;
    positionX = clampPosition(startPositionX - (deltaX / Math.max(rect.width, 1)) * 100);
    positionY = clampPosition(startPositionY - (deltaY / Math.max(rect.height, 1)) * 100);
    setImagePosition();
    event.preventDefault();
  });

  const stopPanning = (event) => {
    if (!isDragging) return;
    isDragging = false;
    frame.classList.remove('is-panning');
    frame.releasePointerCapture?.(event.pointerId);
  };

  frame.addEventListener('pointerup', stopPanning);
  frame.addEventListener('pointercancel', stopPanning);
  frame.addEventListener('lostpointercapture', () => {
    isDragging = false;
    frame.classList.remove('is-panning');
  });
});

document.querySelectorAll('[data-project-before-after]').forEach((comparison) => {
  const handle = comparison.querySelector('[data-project-before-after-handle]');
  if (!handle) return;

  let isDragging = false;
  let position = 50;

  const setPosition = (value) => {
    position = clamp(value, 0, 100);
    comparison.style.setProperty('--before-after-position', `${position.toFixed(2)}%`);
    handle.setAttribute('aria-valuenow', Math.round(position).toString());
  };

  const positionFromPointer = (event) => {
    const rect = comparison.getBoundingClientRect();
    return ((event.clientX - rect.left) / Math.max(rect.width, 1)) * 100;
  };

  const startDrag = (event) => {
    isDragging = true;
    setPosition(positionFromPointer(event));
    comparison.classList.add('is-dragging');
    handle.setPointerCapture?.(event.pointerId);
    event.preventDefault();
  };

  const drag = (event) => {
    if (!isDragging) return;
    setPosition(positionFromPointer(event));
    event.preventDefault();
  };

  const stopDrag = (event) => {
    if (!isDragging) return;
    isDragging = false;
    comparison.classList.remove('is-dragging');
    handle.releasePointerCapture?.(event.pointerId);
  };

  comparison.addEventListener('pointerdown', startDrag);
  comparison.addEventListener('pointermove', drag);
  comparison.addEventListener('pointerup', stopDrag);
  comparison.addEventListener('pointercancel', stopDrag);
  comparison.addEventListener('lostpointercapture', () => {
    isDragging = false;
    comparison.classList.remove('is-dragging');
  });

  handle.addEventListener('keydown', (event) => {
    const step = event.shiftKey ? 10 : 4;
    if (event.key === 'ArrowLeft') {
      setPosition(position - step);
      event.preventDefault();
    } else if (event.key === 'ArrowRight') {
      setPosition(position + step);
      event.preventDefault();
    } else if (event.key === 'Home') {
      setPosition(0);
      event.preventDefault();
    } else if (event.key === 'End') {
      setPosition(100);
      event.preventDefault();
    }
  });

  setPosition(position);
});

const mobileOverviewMedia = document.querySelector('[data-mobile-overview-media]');
if (mobileOverviewMedia) {
  const placeMobileOverviewMedia = () => {
    const statement = mobileOverviewMedia.closest('.project-article__statement');
    const rte = statement?.querySelector('.rte');
    const firstParagraph = rte?.querySelector('p');
    if (!rte || !firstParagraph) return;

    if (window.matchMedia('(max-width: 900px)').matches) {
      if (mobileOverviewMedia.parentElement !== rte || mobileOverviewMedia.previousElementSibling !== firstParagraph) {
        firstParagraph.insertAdjacentElement('afterend', mobileOverviewMedia);
      }
      return;
    }

    if (mobileOverviewMedia.parentElement === rte) {
      statement.appendChild(mobileOverviewMedia);
    }
  };

  placeMobileOverviewMedia();
  window.addEventListener('resize', placeMobileOverviewMedia);
}

const aboutRevealImages = document.querySelectorAll('[data-about-image-reveal]');
if (aboutRevealImages.length) {
  const revealAboutImage = (image) => image.classList.add('is-visible');
  const checkAboutImages = () => {
    aboutRevealImages.forEach((image) => {
      if (image.classList.contains('is-visible')) return;
      const rect = image.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.78 && rect.bottom > window.innerHeight * 0.05) {
        revealAboutImage(image);
      }
    });
  };

  checkAboutImages();
  window.addEventListener('scroll', checkAboutImages, { passive: true });
  window.addEventListener('resize', checkAboutImages);
}

let copyToastTimer;

function ensureCopyToast() {
  let toast = document.querySelector('[data-copy-toast]');
  if (toast) return toast;

  toast = document.createElement('div');
  toast.className = 'clipboard-toast';
  toast.setAttribute('data-copy-toast', '');
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.setAttribute('aria-atomic', 'true');

  const text = document.createElement('span');
  text.className = 'clipboard-toast__text';
  toast.appendChild(text);
  document.body.appendChild(toast);
  return toast;
}

function showCopyToast(message) {
  const toast = ensureCopyToast();
  toast.querySelector('.clipboard-toast__text').textContent = message;
  window.clearTimeout(copyToastTimer);
  toast.classList.add('is-visible');
  copyToastTimer = window.setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 2200);
}

async function copyTextToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  textArea.remove();
}

document.querySelectorAll('[data-copy-current-url]').forEach((button) => {
  button.addEventListener('click', async () => {
    try {
      await copyTextToClipboard(window.location.href);
      button.classList.add('is-copied');
      button.setAttribute('aria-label', 'Article link copied');
      showCopyToast('Link copied');
      window.setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', button.dataset.originalLabel || 'Copy article link');
      }, 1800);
    } catch (error) {
      window.location.href = `mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent(window.location.href)}`;
    }
  });
  button.dataset.originalLabel = button.getAttribute('aria-label') || 'Copy article link';
});

const articleGallery = document.querySelector('.project-article__gallery--hba');
if (articleGallery) {
  const galleryItems = Array.from(articleGallery.querySelectorAll('.project-article__gallery-image'));
  const galleryViewport = articleGallery.querySelector('.project-article__gallery-viewport');
  const galleryTrack = articleGallery.querySelector('[data-article-gallery-track]');
  const galleryDots = Array.from(articleGallery.querySelectorAll('[data-article-gallery-dot]'));
  let articleGalleryIndex = 0;
  let galleryDragStartX = 0;
  let galleryDragDeltaX = 0;
  let galleryIsDragging = false;

  const updateArticleGallery = () => {
    if (!galleryTrack) return;
    galleryTrack.style.transform = `translate3d(${-articleGalleryIndex * 100}%, 0, 0)`;
    galleryItems.forEach((item, index) => {
      item.classList.toggle('is-current', index === articleGalleryIndex);
      if (Math.abs(index - articleGalleryIndex) <= 1) {
        item.classList.add('is-visible');
      }
    });
    galleryDots.forEach((dot, index) => {
      const isCurrent = index === articleGalleryIndex;
      dot.classList.toggle('is-current', isCurrent);
      if (isCurrent) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  const moveArticleGallery = (direction) => {
    if (!galleryItems.length) return;
    articleGalleryIndex = (articleGalleryIndex + direction + galleryItems.length) % galleryItems.length;
    updateArticleGallery();
  };

  updateArticleGallery();
  galleryDots.forEach((dot) => {
    dot.addEventListener('click', () => {
      articleGalleryIndex = clamp(Number(dot.dataset.articleGalleryDot) || 0, 0, galleryItems.length - 1);
      updateArticleGallery();
    });
  });

  if (galleryViewport) {
    const commitGalleryDrag = (deltaX) => {
      const threshold = Math.max(42, galleryViewport.getBoundingClientRect().width * .08);
      if (Math.abs(deltaX) > threshold) {
        moveArticleGallery(deltaX < 0 ? 1 : -1);
      }
    };

    const startGalleryDrag = (clientX) => {
      galleryIsDragging = true;
      galleryDragStartX = clientX;
      galleryDragDeltaX = 0;
      galleryViewport.classList.add('is-dragging');
    };

    const endGalleryDrag = (clientX) => {
      if (!galleryIsDragging) return;
      commitGalleryDrag(clientX - galleryDragStartX || galleryDragDeltaX);
      galleryIsDragging = false;
      galleryDragDeltaX = 0;
      galleryViewport.classList.remove('is-dragging');
    };

    galleryViewport.addEventListener('mousedown', (event) => {
      if (event.button !== 0 || event.target.closest('[data-article-gallery-dot]')) return;
      startGalleryDrag(event.clientX);
      event.preventDefault();
    });

    window.addEventListener('mousemove', (event) => {
      if (!galleryIsDragging) return;
      galleryDragDeltaX = event.clientX - galleryDragStartX;
    });

    window.addEventListener('mouseup', (event) => {
      endGalleryDrag(event.clientX);
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchDeltaX = 0;
    galleryViewport.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch?.clientX || 0;
      touchStartY = touch?.clientY || 0;
      touchDeltaX = 0;
      galleryIsDragging = false;
    }, { passive: true });

    galleryViewport.addEventListener('touchmove', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;
      touchDeltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (Math.abs(touchDeltaX) > Math.abs(deltaY)) {
        event.preventDefault();
      }
    }, { passive: false });

    galleryViewport.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || touchStartX;
      commitGalleryDrag(touchDeltaX || touchEndX - touchStartX);
      touchDeltaX = 0;
    }, { passive: true });
  }

  document.querySelector('[data-article-gallery-prev]')?.addEventListener('click', () => moveArticleGallery(-1));
  document.querySelector('[data-article-gallery-next]')?.addEventListener('click', () => moveArticleGallery(1));
}

const articleRelatedTrack = document.querySelector('[data-article-related-track]');
if (articleRelatedTrack) {
  const relatedStep = () => {
    const card = articleRelatedTrack.querySelector('.projects-card');
    if (!card) return articleRelatedTrack.clientWidth * 0.82;
    const gap = parseFloat(window.getComputedStyle(articleRelatedTrack).columnGap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  };

  document.querySelector('[data-related-prev]')?.addEventListener('click', () => {
    articleRelatedTrack.scrollBy({ left: -relatedStep(), behavior: 'smooth' });
  });

  document.querySelector('[data-related-next]')?.addEventListener('click', () => {
    articleRelatedTrack.scrollBy({ left: relatedStep(), behavior: 'smooth' });
  });
}

const articleRelatedSection = document.querySelector('.project-article__related--hba');
const articleRelatedFilter = document.querySelector('[data-article-related-filter]');
if (articleRelatedSection && articleRelatedTrack && articleRelatedFilter) {
  const relatedCards = Array.from(articleRelatedTrack.querySelectorAll('[data-project-card]'));
  const relatedFilterGroups = Array.from(articleRelatedFilter.querySelectorAll('.projects-filter__group'));
  const relatedFilterToggles = Array.from(articleRelatedFilter.querySelectorAll('[data-article-related-filter-toggle]'));
  const relatedFilterButtons = Array.from(articleRelatedFilter.querySelectorAll('[data-article-related-filter-value]'));
  const relatedFilterLabels = {
    expertise: articleRelatedFilter.querySelector('[data-article-related-filter-label="expertise"]'),
    region: articleRelatedFilter.querySelector('[data-article-related-filter-label="region"]')
  };
  const relatedSearchForm = articleRelatedFilter.querySelector('[data-article-related-search-form]');
  const relatedSearchInput = articleRelatedFilter.querySelector('[data-article-related-search]');
  const relatedFilterState = {
    expertise: articleRelatedFilter.dataset.initialExpertise || 'all',
    region: articleRelatedFilter.dataset.initialRegion || 'all',
    query: ''
  };
  let relatedFilterRaf = null;

  function syncArticleRelatedFilterVisibility() {
    const rect = articleRelatedSection.getBoundingClientRect();
    const shouldShow = rect.top < window.innerHeight * 0.82 && rect.bottom > window.innerHeight * 0.16;
    articleRelatedFilter.classList.toggle('is-visible', shouldShow);
    if (!shouldShow) closeArticleRelatedDrawers();
  }

  function scheduleArticleRelatedFilterVisibility() {
    if (relatedFilterRaf) return;
    relatedFilterRaf = window.requestAnimationFrame(() => {
      relatedFilterRaf = null;
      syncArticleRelatedFilterVisibility();
    });
  }

  function closeArticleRelatedDrawers(except) {
    relatedFilterGroups.forEach((group) => {
      if (group !== except) group.classList.remove('is-open');
    });
  }

  function syncArticleRelatedDrawerOverflow() {
    articleRelatedFilter.querySelectorAll('.projects-filter__drawer').forEach((drawer) => {
      drawer.classList.toggle('has-overflow', drawer.scrollHeight > drawer.clientHeight + 2);
    });
  }

  function updateArticleRelatedCards() {
    relatedCards.forEach((card) => {
      const matchesExpertise = relatedFilterState.expertise === 'all' || card.dataset.expertise === relatedFilterState.expertise;
      const matchesRegion = relatedFilterState.region === 'all' || card.dataset.region === relatedFilterState.region;
      const haystack = (card.dataset.search || '').toLowerCase();
      const matchesSearch = !relatedFilterState.query || haystack.includes(relatedFilterState.query);
      const visible = matchesExpertise && matchesRegion && matchesSearch;
      card.classList.toggle('is-hidden', !visible);
      card.classList.toggle('is-soft-hidden', !visible);
    });
  }

  relatedFilterToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const group = toggle.closest('.projects-filter__group');
      const willOpen = !group.classList.contains('is-open');
      closeArticleRelatedDrawers(group);
      group.classList.toggle('is-open', willOpen);
      window.requestAnimationFrame(syncArticleRelatedDrawerOverflow);
    });
  });

  relatedFilterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const [kind, value] = button.dataset.articleRelatedFilterValue.split(':');
      if (kind === 'expertise') {
        const targetUrl = button.dataset.articleRelatedExpertiseUrl || `/blogs/news?view=expertise${value === 'all' ? '' : `#${value}`}`;
        window.location.href = targetUrl;
        return;
      }
      relatedFilterState[kind] = value;
      if (relatedFilterLabels[kind]) relatedFilterLabels[kind].textContent = button.textContent.trim();
      closeArticleRelatedDrawers();
      updateArticleRelatedCards();
    });
  });

  relatedSearchInput?.addEventListener('focus', () => closeArticleRelatedDrawers());

  relatedSearchInput?.addEventListener('input', () => {
    relatedFilterState.query = relatedSearchInput.value.trim().toLowerCase();
    updateArticleRelatedCards();
  });

  relatedSearchForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    relatedFilterState.query = relatedSearchInput?.value.trim().toLowerCase() || '';
    updateArticleRelatedCards();
  });

  document.addEventListener('click', (event) => {
    if (!articleRelatedFilter.contains(event.target)) closeArticleRelatedDrawers();
  });

  syncArticleRelatedFilterVisibility();
  syncArticleRelatedDrawerOverflow();
  updateArticleRelatedCards();
  window.addEventListener('scroll', scheduleArticleRelatedFilterVisibility, { passive: true });
  window.addEventListener('resize', () => {
    syncArticleRelatedFilterVisibility();
    syncArticleRelatedDrawerOverflow();
  });
}

const heroImage = document.querySelector('[data-hero-parallax]');
const homeHero = document.querySelector('[data-home-hero]');
const homeHeroContent = document.querySelector('[data-home-hero-content]');
const expertiseHeroStage = document.querySelector('.expertise-detail__hero-stage');
const hbaStickyGalleries = document.querySelectorAll('[data-hba-sticky-gallery]');
const articleVisualRuns = document.querySelectorAll('.project-article__visual-run');
const aboutDifferenceTracks = document.querySelectorAll('[data-about-difference]');
const colourSections = document.querySelectorAll('[data-colour-scheme]');
const imageColourCache = new WeakMap();
const stickyGalleryMotion = new WeakMap();
const scrollMotionStates = new Map();
const reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
let stickyGalleryRaf = null;
let scrollMotionRaf = null;
let motionUpdateRaf = null;
let smoothPageScrollRaf = null;
let smoothPageScrollCurrent = window.scrollY;
let smoothPageScrollTarget = window.scrollY;
let smoothPageScrollActive = false;
let smoothPageScrollInput = null;
let smoothTouchLastY = null;
let smoothTouchLastDelta = 0;
let smoothTouchLastTime = 0;
let smoothTouchTarget = null;
let touchMotionPauseUntil = 0;
let touchMotionResumeTimer = null;
let touchInterruptStartY = null;
let observedScrollVelocity = 0;
let observedScrollY = window.scrollY;
let observedScrollTime = performance.now();

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function translateYFromTransform(element) {
  if (!element) return 0;
  const transform = window.getComputedStyle(element).transform;
  if (!transform || transform === 'none') return 0;

  const values = transform.match(/matrix(3d)?\(([^)]+)\)/);
  if (!values) return 0;

  const parts = values[2].split(',').map((part) => Number.parseFloat(part.trim()));
  return values[1] === '3d' ? (parts[13] || 0) : (parts[5] || 0);
}

function easeInOut(value) {
  return value * value * (3 - 2 * value);
}

function easeOutSoft(value) {
  return 1 - Math.pow(1 - value, 3);
}

function maxPageScrollY() {
  return Math.max(
    document.documentElement.scrollHeight,
    document.body.scrollHeight
  ) - window.innerHeight;
}

function normalizeWheelDelta(event) {
  if (event.deltaMode === 1) return event.deltaY * 18;
  if (event.deltaMode === 2) return event.deltaY * window.innerHeight;
  return event.deltaY;
}

function setWindowScrollY(value) {
  const root = document.documentElement;
  const previousScrollBehavior = root.style.scrollBehavior;
  root.style.scrollBehavior = 'auto';
  window.scrollTo(0, value);
  root.style.scrollBehavior = previousScrollBehavior;
}

function setMobileScrollLag(value = 0) {
  document.documentElement.style.setProperty('--mobile-scroll-lag', `${value.toFixed(2)}px`);
}

function isTouchMotionPaused() {
  return !desktopMedia.matches && performance.now() < touchMotionPauseUntil;
}

function pauseTouchInterruptedMotion(duration = 240) {
  if (desktopMedia.matches) return;

  touchMotionPauseUntil = Math.max(touchMotionPauseUntil, performance.now() + duration);

  if (motionUpdateRaf) {
    window.cancelAnimationFrame(motionUpdateRaf);
    motionUpdateRaf = null;
  }
  if (scrollMotionRaf) {
    window.cancelAnimationFrame(scrollMotionRaf);
    scrollMotionRaf = null;
  }
  if (stickyGalleryRaf) {
    window.cancelAnimationFrame(stickyGalleryRaf);
    stickyGalleryRaf = null;
  }

  window.clearTimeout(touchMotionResumeTimer);
  touchMotionResumeTimer = window.setTimeout(() => {
    scheduleMotionUpdate();
  }, duration + 40);
}

function observeNativeScrollVelocity() {
  const now = performance.now();
  const elapsed = Math.max(now - observedScrollTime, 16);
  const nextScrollY = window.scrollY;
  observedScrollVelocity = (nextScrollY - observedScrollY) / elapsed;
  observedScrollY = nextScrollY;
  observedScrollTime = now;
}

function handleTouchMotionInterruptStart(event) {
  if (desktopMedia.matches || event.touches.length !== 1 || !isAboutDifferenceCoverInTouchRange()) return;

  touchInterruptStartY = event.touches[0].clientY;
}

function handleTouchMotionInterruptMove(event) {
  if (desktopMedia.matches || touchInterruptStartY === null || event.touches.length !== 1 || !isAboutDifferenceCoverInTouchRange()) return;

  const touchDelta = touchInterruptStartY - event.touches[0].clientY;
  const reversingMomentum = Math.abs(touchDelta) > 8 && Math.sign(touchDelta) !== Math.sign(observedScrollVelocity);
  if (reversingMomentum && Math.abs(observedScrollVelocity) > 0.06) {
    pauseTouchInterruptedMotion(140);
  }
}

function handleTouchMotionInterruptEnd() {
  touchInterruptStartY = null;
}

function isAboutDifferenceCoverInTouchRange() {
  if (desktopMedia.matches) return false;
  return Array.from(aboutDifferenceTracks).some((section) => {
    if (!section.classList.contains('about-difference--cover')) return false;
    const rect = section.getBoundingClientRect();
    return rect.top < window.innerHeight * 1.12 && rect.bottom > -window.innerHeight * 0.12;
  });
}

function canScrollInside(element, deltaY) {
  let current = element;

  while (current && current !== document.body && current !== document.documentElement) {
    const style = window.getComputedStyle(current);
    const scrollableY = /(auto|scroll|overlay)/.test(style.overflowY);

    if (scrollableY && current.scrollHeight > current.clientHeight + 1) {
      const canScrollDown = current.scrollTop + current.clientHeight < current.scrollHeight - 1;
      const canScrollUp = current.scrollTop > 1;
      if ((deltaY > 0 && canScrollDown) || (deltaY < 0 && canScrollUp)) return true;
    }

    current = current.parentElement;
  }

  return false;
}

function shouldSmoothPageScroll(event) {
  if (learningPortal) return false;
  if (!desktopMedia.matches || reducedMotionMedia.matches) return false;
  if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey) return false;
  if (document.body.classList.contains('nav-open') || document.body.style.overflow === 'hidden') return false;

  const target = event.target instanceof Element ? event.target : null;
  if (!target) return false;
  const formControl = target.closest('input, textarea, select, option, [contenteditable="true"], [data-no-smooth-scroll]');
  if (formControl && !(contactPage && target.closest('.contact-hba__form'))) return false;

  return !canScrollInside(target, event.deltaY);
}

function shouldSmoothPageTouch(event, deltaY) {
  if (learningPortal) return false;
  if (desktopMedia.matches || reducedMotionMedia.matches) return false;
  if (event.defaultPrevented || event.touches.length !== 1) return false;
  if (document.body.classList.contains('nav-open') || document.body.style.overflow === 'hidden') return false;
  if (isAboutDifferenceCoverInTouchRange()) return false;

  const target = smoothTouchTarget || (event.target instanceof Element ? event.target : null);
  if (!target) return false;
  if (target.closest('input, textarea, select, option, [contenteditable="true"], [data-no-smooth-scroll]')) return false;
  if (target.closest('.about-difference--cover .about-difference__track')) return false;

  return !canScrollInside(target, deltaY);
}

function animateSmoothPageScroll() {
  const delta = smoothPageScrollTarget - smoothPageScrollCurrent;
  const resting = Math.abs(delta) < 0.45;

  if (resting) {
    smoothPageScrollCurrent = smoothPageScrollTarget;
    smoothPageScrollActive = false;
    smoothPageScrollInput = null;
    smoothPageScrollRaf = null;
    setWindowScrollY(smoothPageScrollCurrent);
    setMobileScrollLag(0);
    updateMotion();
    return;
  }

  smoothPageScrollActive = true;
  const distance = Math.abs(delta);
  const ease = smoothPageScrollInput === 'touch'
    ? (distance > 560 ? 0.112 : distance > 180 ? 0.078 : 0.044)
    : (distance > 560 ? 0.058 : distance > 180 ? 0.04 : 0.022);
  smoothPageScrollCurrent += delta * ease;
  setWindowScrollY(smoothPageScrollCurrent);
  setMobileScrollLag(0);
  updateMotion();
  smoothPageScrollRaf = window.requestAnimationFrame(animateSmoothPageScroll);
}

function startSmoothPageScroll() {
  const delta = smoothPageScrollTarget - smoothPageScrollCurrent;
  if (Math.abs(delta) > 0.5) {
    smoothPageScrollActive = true;
    smoothPageScrollCurrent += delta * (smoothPageScrollInput === 'touch' ? 0.028 : 0.012);
    setWindowScrollY(smoothPageScrollCurrent);
    updateMotion();
  }
  scheduleSmoothPageScroll();
}

function scheduleSmoothPageScroll() {
  if (!smoothPageScrollRaf) {
    smoothPageScrollRaf = window.requestAnimationFrame(animateSmoothPageScroll);
  }
}

function handleSmoothPageWheel(event) {
  if (!shouldSmoothPageScroll(event)) return;

  const delta = normalizeWheelDelta(event);
  if (!delta) return;

  if (event.cancelable) event.preventDefault();
  const softenedDelta = clamp(delta, -620, 620) * 1.25;
  if (!smoothPageScrollActive) {
    smoothPageScrollCurrent = window.scrollY;
    smoothPageScrollTarget = window.scrollY;
  }
  smoothPageScrollInput = 'wheel';
  smoothPageScrollTarget = clamp(smoothPageScrollTarget + softenedDelta, 0, maxPageScrollY());

  if (!smoothPageScrollRaf) startSmoothPageScroll();
}

function handleSmoothPageTouchStart(event) {
  if (event.touches.length !== 1) return;
  if (!desktopMedia.matches && smoothPageScrollRaf) {
    window.cancelAnimationFrame(smoothPageScrollRaf);
    smoothPageScrollRaf = null;
    smoothPageScrollActive = false;
    smoothPageScrollCurrent = window.scrollY;
    smoothPageScrollTarget = window.scrollY;
    setMobileScrollLag(0);
  }
  smoothTouchLastY = event.touches[0].clientY;
  smoothTouchLastDelta = 0;
  smoothTouchLastTime = performance.now();
  smoothTouchTarget = event.target instanceof Element ? event.target : null;
}

function handleSmoothPageTouchMove(event) {
  if (smoothTouchLastY === null || event.touches.length !== 1) return;

  const nextY = event.touches[0].clientY;
  const delta = smoothTouchLastY - nextY;
  smoothTouchLastY = nextY;

  if (Math.abs(delta) < 0.25) return;
  if (!shouldSmoothPageTouch(event, delta)) return;

  if (event.cancelable) event.preventDefault();
  if (!event.cancelable) return;
  const now = performance.now();
  const elapsed = Math.max(now - smoothTouchLastTime, 16);
  smoothTouchLastDelta = delta / elapsed;
  smoothTouchLastTime = now;

  if (!smoothPageScrollActive) {
    smoothPageScrollCurrent = window.scrollY;
    smoothPageScrollTarget = window.scrollY;
  }

  smoothPageScrollInput = 'touch';
  const softenedDelta = clamp(delta, -118, 118) * 1.72;
  smoothPageScrollTarget = clamp(smoothPageScrollTarget + softenedDelta, 0, maxPageScrollY());

  if (!smoothPageScrollRaf) startSmoothPageScroll();
}

function handleSmoothPageTouchEnd() {
  if (smoothTouchLastY === null) return;
  if (learningPortal) {
    smoothTouchLastY = null;
    smoothTouchLastDelta = 0;
    smoothTouchTarget = null;
    return;
  }
  if (isAboutDifferenceCoverInTouchRange()) {
    smoothTouchLastY = null;
    smoothTouchLastDelta = 0;
    smoothTouchTarget = null;
    smoothPageScrollActive = false;
    smoothPageScrollInput = null;
    if (smoothPageScrollRaf) {
      window.cancelAnimationFrame(smoothPageScrollRaf);
      smoothPageScrollRaf = null;
    }
    smoothPageScrollCurrent = window.scrollY;
    smoothPageScrollTarget = window.scrollY;
    setMobileScrollLag(0);
    return;
  }

  const momentum = clamp(smoothTouchLastDelta * 420, -920, 920);
  if (Math.abs(momentum) > 10 && !reducedMotionMedia.matches && !desktopMedia.matches) {
    if (!smoothPageScrollActive) {
      smoothPageScrollCurrent = window.scrollY;
      smoothPageScrollTarget = window.scrollY;
    }
    smoothPageScrollInput = 'touch';
    smoothPageScrollTarget = clamp(smoothPageScrollTarget + momentum, 0, maxPageScrollY());
    if (!smoothPageScrollRaf) startSmoothPageScroll();
  }

  smoothTouchLastY = null;
  smoothTouchLastDelta = 0;
  smoothTouchTarget = null;
}

function motionEaseForDelta(delta) {
  const distance = Math.abs(delta);
  if (distance > 0.18) return 0.12;
  if (distance > 0.06) return 0.095;
  return 0.072;
}

function getScrollMotionState(element, target = 0) {
  let state = scrollMotionStates.get(element);
  if (!state) {
    state = { current: target, target, ease: 0.085, initialized: false };
    scrollMotionStates.set(element, state);
  }
  return state;
}

function setScrollMotionTarget(element, target, apply) {
  const state = getScrollMotionState(element, target);
  state.target = target;
  state.apply = apply;

  if (!state.initialized) {
    state.current = target;
    state.initialized = true;
    apply(element, target);
    return;
  }

  state.ease = motionEaseForDelta(target - state.current);
  if (!scrollMotionRaf) {
    scrollMotionRaf = window.requestAnimationFrame(animateScrollMotion);
  }
}

function snapScrollMotionTarget(element, target, apply) {
  const state = getScrollMotionState(element, target);
  state.current = target;
  state.target = target;
  state.apply = apply;
  state.initialized = true;
}

function animateScrollMotion() {
  let needsAnotherFrame = false;

  scrollMotionStates.forEach((state, element) => {
    if (!state.apply) return;

    const delta = state.target - state.current;
    const resting = Math.abs(delta) < 0.0007;
    state.current = resting ? state.target : state.current + delta * state.ease;
    state.apply(element, state.current);
    if (!resting) needsAnotherFrame = true;
  });

  scrollMotionRaf = needsAnotherFrame
    ? window.requestAnimationFrame(animateScrollMotion)
    : null;
}

function applyHomeHeroMotion(hero, rawProgress) {
  const progress = easeInOut(rawProgress);
  const mediaY = progress * Math.min(window.innerHeight * 0.035, 34);
  const mediaScale = 1.08 - (progress * 0.018);

  hero.style.setProperty('--home-hero-progress', progress.toFixed(4));
  hero.style.setProperty('--home-hero-lift', '0.00px');
  hero.style.setProperty('--home-hero-media-y', `${mediaY.toFixed(2)}px`);
  hero.style.setProperty('--home-hero-media-scale', mediaScale.toFixed(4));
  hero.style.setProperty('--home-hero-content-y', '0.00px');
  hero.style.setProperty('--home-hero-content-opacity', '1.0000');
}

function applyHeroImageParallax(image, rawOffset) {
  const offset = Math.min(rawOffset, 72);
  image.style.transform = `scale(1.08) translate3d(0, ${offset.toFixed(2)}px, 0)`;
}

function applyArticleVisualMotion(run, progress) {
  const fullImageSettle = easeInOut(clamp(progress / 0.28, 0, 1));
  const galleryEnter = easeInOut(clamp((progress - 0.26) / 0.3, 0, 1));
  const galleryHold = easeInOut(clamp((progress - 0.42) / 0.22, 0, 1));
  const greenWash = easeInOut(clamp((progress - 0.18) / 0.38, 0, 1));

  run.style.setProperty('--article-visual-progress', progress.toFixed(4));
  run.style.setProperty('--article-full-settle', fullImageSettle.toFixed(4));
  run.style.setProperty('--article-gallery-enter', galleryEnter.toFixed(4));
  run.style.setProperty('--article-gallery-hold', galleryHold.toFixed(4));
  run.style.setProperty('--article-green-wash', greenWash.toFixed(4));
  run.classList.toggle('is-gallery-interactive', galleryEnter > 0.12);
}

function applyAboutDifferenceMotion(section, progress) {
  const coverOne = easeInOut(clamp((progress - 0.12) / 0.22, 0, 1));
  const coverTwo = easeInOut(clamp((progress - 0.58) / 0.22, 0, 1));

  section.style.setProperty('--difference-progress', progress.toFixed(4));
  section.style.setProperty('--difference-cover-one', coverOne.toFixed(4));
  section.style.setProperty('--difference-cover-two', coverTwo.toFixed(4));
}

function applyStickyGalleryMotion(gallery, progress, viewportPresence = 0) {
  const mobileGallery = window.matchMedia('(max-width: 749px)').matches;
  const trackStart = mobileGallery ? 0.24 : 0.035;
  const trackDuration = mobileGallery ? 1.36 : 0.82;
  const trackProgress = easeInOut(clamp((progress - trackStart) / trackDuration, 0, 1));
  const overlayOne = easeOutSoft(clamp((progress - 0.035) / 0.26, 0, 1));
  const overlayOneExit = easeInOut(clamp((progress - 0.43) / 0.26, 0, 1));
  const overlayOneOpacity = overlayOne * (1 - overlayOneExit * 0.28);
  const overlayTwo = easeOutSoft(clamp((progress - 0.42) / 0.34, 0, 1));
  const overlayTwoExit = easeInOut(clamp((progress - 0.88) / 0.12, 0, 1));
  const contentBg = easeInOut(clamp((progress - 0.04) / 0.9, 0, 1));
  const floatDrift = easeInOut(clamp(progress, 0, 1));
  const transferMask = easeInOut(clamp((progress - 0.26) / 0.34, 0, 1));
  const presenceEase = easeOutSoft(clamp(viewportPresence, 0, 1));
  const contentIn = Math.max(
    easeOutSoft(clamp(progress / 0.16, 0, 1)),
    presenceEase
  );
  const contentOpacity = Math.min(contentIn, presenceEase);
  const contentY = (1 - contentOpacity) * 18;

  gallery.style.setProperty('--gallery-progress', progress.toFixed(4));
  gallery.style.setProperty('--gallery-track', trackProgress.toFixed(4));
  gallery.style.setProperty('--gallery-slide-one', overlayOne.toFixed(4));
  gallery.style.setProperty('--gallery-slide-one-opacity', overlayOneOpacity.toFixed(4));
  gallery.style.setProperty('--gallery-slide-one-exit', overlayOneExit.toFixed(4));
  gallery.style.setProperty('--gallery-slide-two', overlayTwo.toFixed(4));
  gallery.style.setProperty('--gallery-slide-two-exit', overlayTwoExit.toFixed(4));
  gallery.style.setProperty('--gallery-bg', contentBg.toFixed(4));
  gallery.style.setProperty('--gallery-float', floatDrift.toFixed(4));
  gallery.style.setProperty('--gallery-transfer-mask', transferMask.toFixed(4));
  gallery.style.setProperty('--gallery-content-opacity', contentOpacity.toFixed(4));
  gallery.style.setProperty('--gallery-content-y', `${contentY.toFixed(2)}px`);
}

function animateStickyGalleryMotion() {
  let needsAnotherFrame = false;

  hbaStickyGalleries.forEach((gallery) => {
    const state = stickyGalleryMotion.get(gallery);
    if (!state) return;

    const delta = state.target - state.current;
    const presenceDelta = (state.presence || 0) - (state.currentPresence || 0);
    const resting = Math.abs(delta) < 0.0007 && Math.abs(presenceDelta) < 0.0007;
    state.current = resting ? state.target : state.current + delta * state.ease;
    state.currentPresence = resting
      ? (state.presence || 0)
      : (state.currentPresence || 0) + presenceDelta * state.ease;
    applyStickyGalleryMotion(gallery, state.current, state.currentPresence);
    if (!resting) needsAnotherFrame = true;
  });

  stickyGalleryRaf = needsAnotherFrame
    ? window.requestAnimationFrame(animateStickyGalleryMotion)
    : null;
}

function setStickyGalleryTarget(gallery, target, presence = 0) {
  let state = stickyGalleryMotion.get(gallery);
  if (!state) {
    state = { current: target, target, presence, currentPresence: presence, ease: 0.085 };
    stickyGalleryMotion.set(gallery, state);
    applyStickyGalleryMotion(gallery, target, presence);
    return;
  }

  state.target = target;
  state.presence = presence;
  state.ease = Math.abs(target - state.current) > 0.16 ? 0.105 : 0.078;
  if (!stickyGalleryRaf) {
    stickyGalleryRaf = window.requestAnimationFrame(animateStickyGalleryMotion);
  }
}

function snapStickyGalleryTarget(gallery, target, presence = 0) {
  let state = stickyGalleryMotion.get(gallery);
  if (!state) {
    state = { current: target, target, presence, currentPresence: presence, ease: 0.085 };
    stickyGalleryMotion.set(gallery, state);
    return;
  }
  state.current = target;
  state.target = target;
  state.presence = presence;
  state.currentPresence = presence;
}

function parseColourValue(value) {
  if (!value) return null;
  const colour = value.trim();
  const hex = colour.match(/^#([a-f\d]{3}|[a-f\d]{6})$/i);
  if (hex) {
    const raw = hex[1].length === 3
      ? hex[1].split('').map((char) => char + char).join('')
      : hex[1];
    return [
      parseInt(raw.slice(0, 2), 16),
      parseInt(raw.slice(2, 4), 16),
      parseInt(raw.slice(4, 6), 16)
    ];
  }

  const rgb = colour.match(/^rgba?\(([^)]+)\)$/i);
  if (!rgb) return null;
  return rgb[1].split(',').slice(0, 3).map((part) => Number.parseFloat(part.trim()));
}

function isLightColour(value) {
  const channels = parseColourValue(value);
  if (!channels || channels.some((channel) => Number.isNaN(channel))) return false;
  return isNearWhiteChannels(channels);
}

function colourLuminance(channels) {
  const [red, green, blue] = channels.map((channel) => {
    const normalized = channel / 255;
    return normalized <= 0.03928
      ? normalized / 12.92
      : ((normalized + 0.055) / 1.055) ** 2.4;
  });
  return (0.2126 * red) + (0.7152 * green) + (0.0722 * blue);
}

function isNearWhiteChannels(channels) {
  const [red, green, blue] = channels;
  const luminance = colourLuminance(channels);
  const average = (red + green + blue) / 3;
  const spread = Math.max(red, green, blue) - Math.min(red, green, blue);
  return luminance > 0.74 && average > 182 && spread < 86;
}

function isLightSurfaceChannels(channels) {
  const [red, green, blue] = channels;
  const luminance = colourLuminance(channels);
  const average = (red + green + blue) / 3;
  const spread = Math.max(red, green, blue) - Math.min(red, green, blue);
  return luminance > 0.82 && average > 212 && spread < 62;
}

function headerSampleLine() {
  if (!header) return window.innerHeight * 0.12;
  const rect = header.getBoundingClientRect();
  const action = header.querySelector('.header-actions, .desktop-nav, .brand');
  const actionRect = action?.getBoundingClientRect();
  if (actionRect) return actionRect.top + (actionRect.height / 2);
  return rect.top + Math.min(rect.height * 0.42, 86);
}

function backgroundColourAtHeader(sampleY) {
  if (!header || !document.elementsFromPoint) return null;
  const sampleX = Math.min(window.innerWidth - 1, Math.max(1, window.innerWidth * 0.5));
  const elements = document.elementsFromPoint(sampleX, sampleY);
  for (const element of elements) {
    if (header.contains(element) || element === header) continue;
    let current = element;
    while (current && current !== document.documentElement) {
      const colour = window.getComputedStyle(current).backgroundColor;
      if (colour && colour !== 'transparent' && !colour.endsWith(', 0)') && colour !== 'rgba(0, 0, 0, 0)') {
        return colour;
      }
      current = current.parentElement;
    }
  }
  return window.getComputedStyle(document.body).backgroundColor;
}

function objectPositionValue(value, axis) {
  if (!value) return 0.5;
  const parts = value.split(/\s+/);
  const token = parts[axis] || parts[0];
  if (token?.endsWith('%')) return Number.parseFloat(token) / 100;
  if (token === 'left' || token === 'top') return 0;
  if (token === 'right' || token === 'bottom') return 1;
  return 0.5;
}

function imageChannelsAtPoint(image, x, y) {
  if (!image?.complete || !image.naturalWidth || !image.naturalHeight) return null;
  const rect = image.getBoundingClientRect();
  if (!rect.width || !rect.height) return null;

  let cache = imageColourCache.get(image);
  if (!cache) {
    const canvas = document.createElement('canvas');
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    try {
      context.drawImage(image, 0, 0);
    } catch (error) {
      cache = { blocked: true };
      imageColourCache.set(image, cache);
      return null;
    }
    cache = { canvas, context };
    imageColourCache.set(image, cache);
  }
  if (cache.blocked) return null;

  const style = window.getComputedStyle(image);
  const objectFit = style.objectFit || 'fill';
  const posX = objectPositionValue(style.objectPosition, 0);
  const posY = objectPositionValue(style.objectPosition, 1);
  const scale = objectFit === 'contain'
    ? Math.min(rect.width / image.naturalWidth, rect.height / image.naturalHeight)
    : objectFit === 'cover'
      ? Math.max(rect.width / image.naturalWidth, rect.height / image.naturalHeight)
      : null;

  let sourceX;
  let sourceY;
  if (scale) {
    const drawnWidth = image.naturalWidth * scale;
    const drawnHeight = image.naturalHeight * scale;
    const offsetX = (rect.width - drawnWidth) * posX;
    const offsetY = (rect.height - drawnHeight) * posY;
    sourceX = (x - rect.left - offsetX) / scale;
    sourceY = (y - rect.top - offsetY) / scale;
  } else {
    sourceX = ((x - rect.left) / rect.width) * image.naturalWidth;
    sourceY = ((y - rect.top) / rect.height) * image.naturalHeight;
  }

  sourceX = Math.round(clamp(sourceX, 0, image.naturalWidth - 1));
  sourceY = Math.round(clamp(sourceY, 0, image.naturalHeight - 1));

  try {
    return Array.from(cache.context.getImageData(sourceX, sourceY, 1, 1).data).slice(0, 3);
  } catch (error) {
    cache.blocked = true;
    return null;
  }
}

function sampleChannelsAtPoint(x, y) {
  if (!document.elementsFromPoint) return null;
  const policyGallery = document.querySelector('.shopify-policy__container');
  if (policyGallery) {
    const rect = policyGallery.getBoundingClientRect();
    const beforeStyle = window.getComputedStyle(policyGallery, '::before');
    const beforeWidth = Number.parseFloat(beforeStyle.width) || Math.max(360, window.innerWidth / 3);
    if (beforeStyle.content !== 'none' && x >= rect.left && x <= rect.left + beforeWidth && y >= rect.top && y <= Math.max(rect.bottom, window.innerHeight)) {
      return [18, 34, 34];
    }
  }

  const elements = document.elementsFromPoint(x, y);
  for (const element of elements) {
    if (header?.contains(element) || element === header) continue;
    const image = element.tagName === 'IMG' ? element : element.querySelector?.('img');
    if (image) {
      const imageRect = image.getBoundingClientRect();
      if (x >= imageRect.left && x <= imageRect.right && y >= imageRect.top && y <= imageRect.bottom) {
        const channels = imageChannelsAtPoint(image, x, y);
        if (channels) return channels;
      }
    }

    let current = element;
    while (current && current !== document.documentElement) {
      const colour = window.getComputedStyle(current).backgroundColor;
      if (colour && colour !== 'transparent' && !colour.endsWith(', 0)') && colour !== 'rgba(0, 0, 0, 0)') {
        return parseColourValue(colour);
      }
      current = current.parentElement;
    }
  }
  return parseColourValue(window.getComputedStyle(document.body).backgroundColor);
}

function headerSamplePoints(sampleY) {
  if (!header) return [{ element: null, x: window.innerWidth * 0.5, y: sampleY }];
  const selectors = [
    '.desktop-nav > .nav-item > button',
    '.desktop-nav > .nav-item > .nav-top-link',
    '.menu-toggle',
    '[data-search-trigger]'
  ];
  const points = [];
  selectors.forEach((selector) => {
    header.querySelectorAll(selector).forEach((element) => {
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      if (style.display === 'none' || rect.width < 1 || rect.height < 1) return;
      points.push({
        element,
        x: clamp(rect.left + (rect.width / 2), 1, window.innerWidth - 1),
        y: clamp(rect.top + (rect.height / 2), 1, window.innerHeight - 1)
      });
    });
  });
  return points.length ? points : [{ element: null, x: window.innerWidth * 0.5, y: sampleY }];
}

function setHeaderItemsContrast(tone = null) {
  if (!header) return;
  header.querySelectorAll('[data-header-contrast]').forEach((element) => {
    if (!tone) element.removeAttribute('data-header-contrast');
  });
  if (tone) {
    header.querySelectorAll('.desktop-nav > .nav-item > button, .desktop-nav > .nav-item > .nav-top-link, .menu-toggle, [data-search-trigger]').forEach((element) => {
      element.setAttribute('data-header-contrast', tone);
    });
  }
}

function setDesktopNavContrast(tone = null) {
  if (!header) return;
  header.querySelectorAll('.desktop-nav > .nav-item > button, .desktop-nav > .nav-item > .nav-top-link').forEach((element) => {
    if (tone) {
      element.setAttribute('data-header-contrast', tone);
    } else {
      element.removeAttribute('data-header-contrast');
    }
  });
}

function explicitHeaderToneAtPoint(x, y) {
  if (!document.elementsFromPoint) return null;
  const elements = document.elementsFromPoint(
    clamp(x, 1, window.innerWidth - 1),
    clamp(y, 1, window.innerHeight - 1)
  );
  for (const element of elements) {
    if (header?.contains(element) || element === header) continue;
    let current = element;
    while (current && current !== document.documentElement) {
      if (current.dataset?.headerTone) {
        return current.dataset.headerTone === 'dark' ? 'dark' : 'light';
      }
      current = current.parentElement;
    }
  }
  return null;
}

function syncHeaderActionsContrastFromPoint({ compactOnly = true } = {}) {
  if (!header || (compactOnly && !header.classList.contains('is-compact'))) return;
  header.querySelectorAll('.menu-toggle, [data-search-trigger]').forEach((element) => {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    if (style.display === 'none' || rect.width < 1 || rect.height < 1) return;
    const x = rect.left + (rect.width / 2);
    const y = rect.top + (rect.height / 2);
    const explicitTone = explicitHeaderToneAtPoint(x, y);
    const sampledTone = isElementOverLightSurface(element) ? 'dark' : (explicitTone || contrastForElement(element));
    if (sampledTone) element.setAttribute('data-header-contrast', sampledTone);
  });
}

function isElementOverLightSurface(element) {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  if (rect.width < 1 || rect.height < 1) return false;
  const insetX = Math.min(rect.width * 0.28, 14);
  const insetY = Math.min(rect.height * 0.28, 14);
  const points = [
    [rect.left + rect.width / 2, rect.top + rect.height / 2],
    [rect.left + insetX, rect.top + rect.height / 2],
    [rect.right - insetX, rect.top + rect.height / 2],
    [rect.left + rect.width / 2, rect.top + insetY],
    [rect.left + rect.width / 2, rect.bottom - insetY]
  ];
  const samples = points
    .map(([x, y]) => sampleChannelsAtPoint(
      clamp(x, 1, window.innerWidth - 1),
      clamp(y, 1, window.innerHeight - 1)
    ))
    .filter(Boolean);
  if (!samples.length) return false;
  const lightSamples = samples.filter(isLightSurfaceChannels).length;
  return lightSamples / samples.length >= 0.5;
}

function contrastForElement(element) {
  if (!element) return null;
  const rect = element.getBoundingClientRect();
  if (rect.width < 1 || rect.height < 1) return null;
  const insetX = Math.min(rect.width * 0.28, 14);
  const insetY = Math.min(rect.height * 0.28, 14);
  const points = [
    [rect.left + rect.width / 2, rect.top + rect.height / 2],
    [rect.left + insetX, rect.top + rect.height / 2],
    [rect.right - insetX, rect.top + rect.height / 2],
    [rect.left + rect.width / 2, rect.top + insetY],
    [rect.left + rect.width / 2, rect.bottom - insetY]
  ];
  const samples = points
    .map(([x, y]) => sampleChannelsAtPoint(
      clamp(x, 1, window.innerWidth - 1),
      clamp(y, 1, window.innerHeight - 1)
    ))
    .filter(Boolean);
  if (!samples.length) return null;
  const nearWhiteSamples = samples.filter(isNearWhiteChannels).length;
  return nearWhiteSamples / samples.length >= 0.5 ? 'dark' : 'light';
}

function updateMotion() {
  if (isTouchMotionPaused()) return;

  const scrollY = window.scrollY;
  const shouldSnapScrollMotion = smoothPageScrollActive && smoothPageScrollInput !== 'touch';
  if (expertiseHeroStage) {
    const stageTop = expertiseHeroStage.getBoundingClientRect().top + scrollY;
    const stageEnd = stageTop + expertiseHeroStage.offsetHeight - window.innerHeight;
    const isActive = scrollY >= stageTop && scrollY < stageEnd;
    const isAfter = scrollY >= stageEnd;
    expertiseHeroStage.classList.toggle('is-cover-active', isActive);
    expertiseHeroStage.classList.toggle('is-cover-after', isAfter);

    document.querySelectorAll('.expertise-detail__intro-media[data-image-reveal]:not(.is-visible)').forEach((media) => {
      const rect = media.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.86 && rect.bottom > window.innerHeight * 0.08) {
        media.classList.add('is-visible');
      }
    });
  }

  if (homeHero && heroImage) {
    const heroRect = homeHero.getBoundingClientRect();
    const heroHeight = Math.max(homeHero.offsetHeight, window.innerHeight);
    const rawProgress = clamp((0 - heroRect.top) / Math.max(heroHeight * 0.86, 1), 0, 1);
    if (shouldSnapScrollMotion) {
      applyHomeHeroMotion(homeHero, rawProgress);
      snapScrollMotionTarget(homeHero, rawProgress, applyHomeHeroMotion);
    } else {
      setScrollMotionTarget(homeHero, rawProgress, applyHomeHeroMotion);
    }
  } else if (heroImage) {
    const offset = Math.min(scrollY * 0.07, 72);
    if (shouldSnapScrollMotion) {
      applyHeroImageParallax(heroImage, offset);
      snapScrollMotionTarget(heroImage, offset, applyHeroImageParallax);
    } else {
      setScrollMotionTarget(heroImage, offset, applyHeroImageParallax);
    }
  }

  hbaStickyGalleries.forEach((gallery) => {
    const rect = gallery.getBoundingClientRect();
    const travel = gallery.offsetHeight - window.innerHeight;
    const progress = clamp((0 - rect.top) / Math.max(travel, 1), 0, 1);
    const visiblePixels = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    const viewportPresence = clamp(
      visiblePixels / Math.max(Math.min(window.innerHeight * 0.34, gallery.offsetHeight), 1),
      0,
      1
    );
    if (shouldSnapScrollMotion) {
      applyStickyGalleryMotion(gallery, progress, viewportPresence);
      snapStickyGalleryTarget(gallery, progress, viewportPresence);
    } else {
      setStickyGalleryTarget(gallery, progress, viewportPresence);
    }
  });

  articleVisualRuns.forEach((run) => {
    const rect = run.getBoundingClientRect();
    const travel = run.offsetHeight - window.innerHeight;
    const progress = clamp((0 - rect.top) / Math.max(travel, 1), 0, 1);
    if (shouldSnapScrollMotion) {
      applyArticleVisualMotion(run, progress);
      snapScrollMotionTarget(run, progress, applyArticleVisualMotion);
    } else {
      setScrollMotionTarget(run, progress, applyArticleVisualMotion);
    }
  });

  aboutDifferenceTracks.forEach((section) => {
    const heading = section.querySelector('.about-difference__heading');
    const isMobileCover = section.classList.contains('about-difference--cover')
      && window.matchMedia('(max-width: 900px)').matches;
    const track = isMobileCover ? section.querySelector('.about-difference__track') : null;
    const sectionRect = isMobileCover ? section.getBoundingClientRect() : null;
    const mobileCoverFixed = Boolean(
      isMobileCover
        && sectionRect
        && sectionRect.top <= 0
        && sectionRect.bottom > window.innerHeight
    );
    section.classList.toggle('is-mobile-cover-fixed', mobileCoverFixed);
    const motionViewportHeight = isMobileCover && track
      ? Math.max(Math.round(track.getBoundingClientRect().height), 1)
      : window.innerHeight;
    const sectionTop = isMobileCover
      ? section.offsetTop
      : section.getBoundingClientRect().top + window.scrollY;
    const mobileHeadingExit = isMobileCover && heading
      ? heading.offsetTop + heading.offsetHeight + translateYFromTransform(heading)
      : 0;
    const headingExit = isMobileCover
      ? mobileHeadingExit
      : heading
      ? heading.offsetTop + heading.offsetHeight + Math.round(motionViewportHeight * 0.08)
      : Math.round(motionViewportHeight * 0.34);
    const exitCoverDistance = section.classList.contains('about-difference--cover')
      ? (isMobileCover ? motionViewportHeight * 2.4 : motionViewportHeight)
      : 0;
    const travel = Math.max(section.offsetHeight - motionViewportHeight - headingExit - exitCoverDistance, 1);
    const progress = clamp((window.scrollY - sectionTop - headingExit) / travel, 0, 1);
    if (isMobileCover) {
      applyAboutDifferenceMotion(section, progress);
      snapScrollMotionTarget(section, progress, applyAboutDifferenceMotion);
      return;
    }
    if (shouldSnapScrollMotion) {
      applyAboutDifferenceMotion(section, progress);
      snapScrollMotionTarget(section, progress, applyAboutDifferenceMotion);
    } else {
      setScrollMotionTarget(section, progress, applyAboutDifferenceMotion);
    }
  });

  let activeColour = null;
  let explicitHeaderTone = null;
  const colourSampleY = headerSampleLine();
  const samplePoints = headerSamplePoints(colourSampleY);
  const sampledChannels = samplePoints
    .map(({ x, y }) => sampleChannelsAtPoint(x, y))
    .filter(Boolean);
  colourSections.forEach((section) => {
    const rect = section.getBoundingClientRect();
    if (rect.top <= colourSampleY && rect.bottom >= colourSampleY) {
      activeColour = section.dataset.colourScheme;
      explicitHeaderTone = section.dataset.headerTone || null;
      document.documentElement.style.setProperty('--site-colour', activeColour);
    }
  });
  if (expertiseHeroStage && header) {
    const paperSections = document.querySelectorAll('.expertise-detail__intro, .expertise-projects');
    const isOverPaper = Array.from(paperSections).some((section) => {
      const rect = section.getBoundingClientRect();
      return rect.top <= colourSampleY && rect.bottom >= colourSampleY;
    });
    activeColour = isOverPaper ? '#f3eeea' : '#111817';
    explicitHeaderTone = isOverPaper ? 'dark' : 'light';
    document.documentElement.style.setProperty('--site-colour', activeColour);
  }
  if (explicitHeaderTone && header) {
    const tone = explicitHeaderTone === 'dark' ? 'dark' : 'light';
    header.classList.toggle('is-over-light', tone === 'dark');
    setHeaderItemsContrast(tone);
    syncHeaderActionsContrastFromPoint({ compactOnly: !document.querySelector('.about-page--hba') });
  } else if (sampledChannels.length && header) {
    const nearWhiteSamples = sampledChannels.filter(isNearWhiteChannels).length;
    header.classList.toggle('is-over-light', nearWhiteSamples / sampledChannels.length >= 0.45);
    samplePoints.forEach(({ element, x, y }) => {
      if (!element) return;
      const itemTone = contrastForElement(element);
      if (itemTone) {
        element.setAttribute('data-header-contrast', itemTone);
      } else {
        const channels = sampleChannelsAtPoint(x, y);
        element.setAttribute('data-header-contrast', channels && isNearWhiteChannels(channels) ? 'dark' : 'light');
      }
    });
    syncHeaderActionsContrastFromPoint({ compactOnly: !document.querySelector('.about-page--hba') });
  } else if (!activeColour) {
    activeColour = backgroundColourAtHeader(colourSampleY);
    setHeaderItemsContrast(null);
    header.classList.toggle('is-over-light', isLightColour(activeColour));
    syncHeaderActionsContrastFromPoint({ compactOnly: !document.querySelector('.about-page--hba') });
  } else if (header && activeColour) {
    setHeaderItemsContrast(null);
    header.classList.toggle('is-over-light', isLightColour(activeColour));
    syncHeaderActionsContrastFromPoint({ compactOnly: !document.querySelector('.about-page--hba') });
  }
}

function scheduleMotionUpdate() {
  if (motionUpdateRaf) return;
  motionUpdateRaf = window.requestAnimationFrame(() => {
    motionUpdateRaf = null;
    updateMotion();
  });
}

updateMotion();
window.addEventListener('wheel', handleSmoothPageWheel, { passive: false });
window.addEventListener('touchstart', handleTouchMotionInterruptStart, { passive: true });
window.addEventListener('touchmove', handleTouchMotionInterruptMove, { passive: true });
window.addEventListener('touchend', handleTouchMotionInterruptEnd, { passive: true });
window.addEventListener('touchcancel', handleTouchMotionInterruptEnd, { passive: true });
window.addEventListener('scroll', () => {
  observeNativeScrollVelocity();
  if (smoothPageScrollActive) return;
  smoothPageScrollCurrent = window.scrollY;
  smoothPageScrollTarget = window.scrollY;
}, { passive: true });
window.addEventListener('scroll', () => {
  if (!smoothPageScrollActive) scheduleMotionUpdate();
}, { passive: true });
window.addEventListener('resize', () => {
  smoothPageScrollCurrent = window.scrollY;
  smoothPageScrollTarget = clamp(window.scrollY, 0, maxPageScrollY());
  scheduleMotionUpdate();
});

document.querySelectorAll('[data-home-perspectives]').forEach((section) => {
  const track = section.querySelector('[data-home-perspectives-track]');
  const prev = section.querySelector('[data-home-perspectives-prev]');
  const next = section.querySelector('[data-home-perspectives-next]');
  const progress = section.querySelector('[data-home-perspectives-progress]');
  const cards = Array.from(section.querySelectorAll('[data-home-perspectives-card]'));
  if (!track || !cards.length) return;

  function cardStep() {
    const first = cards[0].getBoundingClientRect();
    const second = cards[1]?.getBoundingClientRect();
    return second ? Math.abs(second.left - first.left) : first.width;
  }

  function updateCarouselState() {
    const max = Math.max(track.scrollWidth - track.clientWidth, 1);
    const ratio = clamp(track.scrollLeft / max, 0, 1);
    if (progress) {
      const firstSegment = 100 / cards.length;
      progress.style.setProperty('--perspectives-progress-size', `${firstSegment + ((100 - firstSegment) * ratio)}%`);
      progress.style.setProperty('--perspectives-progress-offset', '0%');
    }
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  function flashButton(button) {
    if (!button) return;
    button.classList.add('is-clicked');
    window.setTimeout(() => button.classList.remove('is-clicked'), 260);
  }

  prev?.addEventListener('click', () => {
    flashButton(prev);
    track.scrollTo({ left: Math.max(track.scrollLeft - cardStep(), 0), behavior: 'smooth' });
  });
  next?.addEventListener('click', () => {
    flashButton(next);
    const max = Math.max(track.scrollWidth - track.clientWidth, 0);
    track.scrollTo({ left: Math.min(track.scrollLeft + cardStep(), max), behavior: 'smooth' });
  });
  track.addEventListener('scroll', updateCarouselState, { passive: true });
  window.addEventListener('resize', updateCarouselState);
  updateCarouselState();
});

document.querySelectorAll('[data-expertise-showcase]').forEach((section) => {
  const cards = Array.from(section.querySelectorAll('[data-expertise-card]'));
  const media = Array.from(section.querySelectorAll('[data-expertise-media]'));
  const viewAll = section.querySelector('[data-expertise-view-all]');
  if (!cards.length || !media.length) return;

  function handleize(value) {
    return value
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9\u4e00-\u9fff]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  if (viewAll) {
    const firstExpertiseItem = document.querySelector('#HeaderPanelExpertise > div:first-child a');
    if (firstExpertiseItem) {
      const itemHref = firstExpertiseItem.getAttribute('href') || '';
      const itemHandle = handleize(firstExpertiseItem.textContent || '');
      const computedHref = itemHref.includes('#') || !itemHandle
        ? itemHref
        : `/blogs/news?view=expertise#${itemHandle}`;
      if (computedHref) viewAll.setAttribute('href', computedHref);
    }
  }

  function setActive(index = 0) {
    cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === index));
    media.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
  }

  cards.forEach((card, index) => {
    card.addEventListener('mouseenter', () => setActive(index));
    card.addEventListener('focus', () => setActive(index));
    card.addEventListener('touchstart', () => setActive(index), { passive: true });
  });

  section.addEventListener('mouseleave', () => setActive(0));
  setActive(0);
});

document.querySelectorAll('[data-courses-view-all]').forEach((viewAll) => {
  const firstCourseItem = document.querySelector('#HeaderPanelCourses a');
  const itemHref = firstCourseItem?.getAttribute('href');
  if (itemHref) viewAll.setAttribute('href', itemHref);
});

const projectsArchive = document.querySelector('[data-projects-archive]');

if (projectsArchive) {
  const cards = Array.from(projectsArchive.querySelectorAll('[data-project-card]'));
  const filterBar = projectsArchive.querySelector('[data-project-filter]');
  const filterGroups = Array.from(projectsArchive.querySelectorAll('.projects-filter__group'));
  const filterToggles = Array.from(projectsArchive.querySelectorAll('[data-project-filter-toggle]'));
  const filterButtons = Array.from(projectsArchive.querySelectorAll('[data-filter-value]'));
  const filterLabels = {
    expertise: projectsArchive.querySelector('[data-filter-label="expertise"]'),
    region: projectsArchive.querySelector('[data-filter-label="region"]')
  };
  const searchForm = projectsArchive.querySelector('[data-project-search-form]');
  const searchInputArchive = projectsArchive.querySelector('[data-project-search]');
  const loadMore = projectsArchive.querySelector('[data-project-load-more]');
  const state = { expertise: 'all', region: 'all', query: '', shown: 6 };
  const expertiseDetail = document.querySelector('[data-expertise-detail]');
  const expertiseDetailTitle = expertiseDetail?.querySelector('[data-expertise-detail-title]');
  const expertiseBreadcrumbCurrent = expertiseDetail?.querySelector('[data-expertise-breadcrumb-current]');
  const initialExpertiseHash = expertiseDetail ? window.location.hash.replace('#', '').trim() : '';

  function syncProjectFilterVisibility() {
    if (!projectsArchive.classList.contains('expertise-projects') || !filterBar) return;
    const rect = projectsArchive.getBoundingClientRect();
    const shouldShow = rect.top < window.innerHeight * 0.72 && rect.bottom > window.innerHeight * 0.18;
    filterBar.classList.toggle('is-visible', shouldShow);
  }

  if (initialExpertiseHash) {
    const initialExpertiseButton = filterButtons.find((button) => button.dataset.filterValue === `expertise:${initialExpertiseHash}`);
    if (initialExpertiseButton) {
      state.expertise = initialExpertiseHash;
      if (filterLabels.expertise) filterLabels.expertise.textContent = initialExpertiseButton.textContent.trim();
      if (expertiseDetailTitle) expertiseDetailTitle.textContent = initialExpertiseButton.textContent.trim();
      if (expertiseBreadcrumbCurrent) expertiseBreadcrumbCurrent.textContent = initialExpertiseButton.textContent.trim();
    }
  }

  function matchingCards() {
    return cards.filter((card) => {
      const matchesExpertise = state.expertise === 'all' || card.dataset.expertise === state.expertise;
      const matchesRegion = state.region === 'all' || card.dataset.region === state.region;
      const haystack = (card.dataset.search || '').toLowerCase();
      const matchesSearch = !state.query || haystack.includes(state.query);
      return matchesExpertise && matchesRegion && matchesSearch;
    });
  }

  function updateProjectGrid() {
    const matches = matchingCards();
    cards.forEach((card) => {
      const index = matches.indexOf(card);
      const visible = index !== -1 && index < state.shown;
      card.classList.toggle('is-hidden', !visible);
      card.classList.toggle('is-soft-hidden', !visible);
    });
    if (loadMore) {
      loadMore.hidden = matches.length <= state.shown;
    }
  }

  function closeProjectDrawers(except) {
    filterGroups.forEach((group) => {
      if (group !== except) group.classList.remove('is-open');
    });
  }

  function syncProjectDrawerOverflow() {
    projectsArchive.querySelectorAll('.projects-filter__drawer').forEach((drawer) => {
      drawer.classList.toggle('has-overflow', drawer.scrollHeight > drawer.clientHeight + 2);
    });
  }

  filterToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const group = toggle.closest('.projects-filter__group');
      const willOpen = !group.classList.contains('is-open');
      closeProjectDrawers(group);
      group.classList.toggle('is-open', willOpen);
      filterBar?.classList.remove('is-search-open');
      window.requestAnimationFrame(syncProjectDrawerOverflow);
    });
  });

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const [kind, value] = button.dataset.filterValue.split(':');
      state[kind] = value;
      state.shown = 6;
      if (filterLabels[kind]) filterLabels[kind].textContent = button.textContent.trim();
      if (kind === 'expertise' && expertiseDetailTitle && value !== 'all') {
        expertiseDetailTitle.textContent = button.textContent.trim();
        if (expertiseBreadcrumbCurrent) expertiseBreadcrumbCurrent.textContent = button.textContent.trim();
        history.replaceState(null, '', `#${value}`);
      }
      if (kind === 'expertise' && expertiseDetailTitle && value === 'all') {
        expertiseDetailTitle.textContent = 'Interiors';
        if (expertiseBreadcrumbCurrent) expertiseBreadcrumbCurrent.textContent = 'Interiors';
      }
      closeProjectDrawers();
      updateProjectGrid();
    });
  });

  searchInputArchive?.addEventListener('focus', () => {
    filterBar?.classList.add('is-search-open');
    closeProjectDrawers();
  });

  searchInputArchive?.addEventListener('input', () => {
    state.query = searchInputArchive.value.trim().toLowerCase();
    state.shown = 6;
    updateProjectGrid();
  });

  searchForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    state.query = searchInputArchive?.value.trim().toLowerCase() || '';
    state.shown = 999;
    updateProjectGrid();
  });

  loadMore?.addEventListener('click', () => {
    state.shown += 6;
    updateProjectGrid();
  });

  document.addEventListener('click', (event) => {
    if (!projectsArchive.contains(event.target)) closeProjectDrawers();
  });

  updateProjectGrid();
  syncProjectFilterVisibility();
  syncProjectDrawerOverflow();
  window.addEventListener('scroll', syncProjectFilterVisibility, { passive: true });
  window.addEventListener('resize', () => {
    syncProjectFilterVisibility();
    syncProjectDrawerOverflow();
  });
}

const expertiseArchive = document.querySelector('[data-expertise-archive]');

if (expertiseArchive) {
  const title = expertiseArchive.querySelector('[data-expertise-title]');
  const filters = Array.from(expertiseArchive.querySelectorAll('[data-expertise-filter]'));
  const cards = Array.from(expertiseArchive.querySelectorAll('[data-expertise-card]'));
  const clears = Array.from(expertiseArchive.querySelectorAll('[data-expertise-clear]'));
  const sidebars = Array.from(expertiseArchive.querySelectorAll('.expertise-archive__sidebar'));
  const filterToggles = Array.from(expertiseArchive.querySelectorAll('[data-expertise-filter-toggle]'));
  const filterCurrentLabels = Array.from(expertiseArchive.querySelectorAll('[data-expertise-filter-current]'));
  const defaultTitle = title?.textContent.trim() || 'Expertise';
  const isJournalArchive = expertiseArchive.classList.contains('expertise-archive--journal');
  const mobileJournalFilter = expertiseArchive.querySelector('.expertise-archive__mobile-filter');
  const archiveGrid = expertiseArchive.querySelector('.expertise-archive__grid');
  const mobileArchiveMedia = window.matchMedia('(max-width: 900px)');

  if (isJournalArchive && mobileArchiveMedia.matches) {
    sidebars.forEach((item) => item.classList.add('is-collapsed'));
    filterToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
  }

  function syncJournalMobileFilterVisibility() {
    if (!isJournalArchive || !mobileJournalFilter || !archiveGrid) return;
    if (!mobileArchiveMedia.matches) {
      mobileJournalFilter.classList.remove('is-mobile-filter-visible');
      return;
    }

    const rect = archiveGrid.getBoundingClientRect();
    const shouldShow = rect.top < window.innerHeight - 58 && rect.bottom > window.innerHeight * 0.16;
    mobileJournalFilter.classList.toggle('is-mobile-filter-visible', shouldShow);
    if (!shouldShow) {
      mobileJournalFilter.classList.add('is-collapsed');
      mobileJournalFilter.querySelector('[data-expertise-filter-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  }

  function getActiveFilter() {
    return decodeURIComponent(window.location.hash.replace('#', '')).trim();
  }

  function applyExpertiseFilter() {
    const active = getActiveFilter();
    const activeFilter = filters.find((filter) => filter.dataset.expertiseFilter === active);

    filters.forEach((filter) => {
      const isActive = active && filter.dataset.expertiseFilter === active;
      filter.classList.toggle('is-active', Boolean(isActive));
      if (isActive) {
        filter.setAttribute('aria-current', 'page');
      } else {
        filter.removeAttribute('aria-current');
      }
    });

    if (title) {
      title.textContent = activeFilter?.dataset.expertiseLabel || defaultTitle;
    }
    filterCurrentLabels.forEach((label) => {
      label.textContent = activeFilter?.dataset.expertiseLabel || 'All';
    });

    cards.forEach((card) => {
      const visible = !active || card.dataset.expertise === active;
      card.classList.toggle('is-hidden', !visible);
    });
  }

  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      window.setTimeout(applyExpertiseFilter, 0);
    });
  });

  clears.forEach((clear) => {
    clear.addEventListener('click', (event) => {
      event.preventDefault();
      history.pushState(null, '', clear.href);
      applyExpertiseFilter();
    });
  });

  filterToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') !== 'false';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.closest('.expertise-archive__sidebar')?.classList.toggle('is-collapsed', expanded);
    });
  });

  window.addEventListener('hashchange', applyExpertiseFilter);
  applyExpertiseFilter();
  syncJournalMobileFilterVisibility();
  window.addEventListener('scroll', syncJournalMobileFilterVisibility, { passive: true });
  window.addEventListener('resize', syncJournalMobileFilterVisibility);
}

document.querySelectorAll('[data-journal-archive-backdrop]').forEach((backdrop) => {
  const archive = backdrop.closest('.expertise-archive--journal') || backdrop;
  const slides = Array.from(backdrop.querySelectorAll('[data-journal-archive-backdrop-slide]'));
  const controls = Array.from(archive.querySelectorAll('[data-journal-archive-backdrop-control]'));
  if (slides.length <= 1) return;

  let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (activeIndex < 0) activeIndex = 0;
  let timer = null;
  let activeSlideCount = slides.length;

  function setJournalBackdrop(index) {
    activeIndex = (index + activeSlideCount) % activeSlideCount;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === activeIndex && !slide.hidden);
    });
    controls.forEach((control, controlIndex) => {
      control.classList.toggle('is-active', controlIndex === activeIndex && !control.hidden);
    });
  }

  function queueJournalBackdrop() {
    window.clearInterval(timer);
    if (activeSlideCount <= 1) return;
    timer = window.setInterval(() => setJournalBackdrop(activeIndex + 1), 4200);
  }

  function syncJournalBackdropImages() {
    const visibleCards = Array.from(archive.querySelectorAll('[data-expertise-card]:not(.is-hidden)'));
    const sources = visibleCards
      .map((card) => card.querySelector('.expertise-article-card__media img'))
      .filter(Boolean)
      .slice(0, slides.length)
      .map((image) => image.currentSrc || image.src);

    activeSlideCount = sources.length;
    slides.forEach((slide, slideIndex) => {
      const source = sources[slideIndex];
      const image = slide.querySelector('img');
      slide.hidden = !source;
      if (source && image && image.getAttribute('src') !== source) {
        image.setAttribute('src', source);
      }
    });
    controls.forEach((control, controlIndex) => {
      control.hidden = controlIndex >= activeSlideCount;
    });
    activeIndex = Math.min(activeIndex, Math.max(activeSlideCount - 1, 0));
    if (activeSlideCount > 0) setJournalBackdrop(activeIndex);
    queueJournalBackdrop();
  }

  controls.forEach((control) => {
    control.addEventListener('click', () => {
      if (control.hidden) return;
      const index = Number(control.dataset.journalArchiveBackdropIndex || 0);
      setJournalBackdrop(index);
      queueJournalBackdrop();
    });
  });

  syncJournalBackdropImages();
  archive.querySelectorAll('[data-expertise-filter], [data-expertise-clear]').forEach((trigger) => {
    trigger.addEventListener('click', () => window.setTimeout(syncJournalBackdropImages, 0));
  });
  window.addEventListener('hashchange', () => window.setTimeout(syncJournalBackdropImages, 0));
});

document.querySelectorAll('[data-courses-list]').forEach((courseList) => {
  const courseCards = Array.from(courseList.querySelectorAll('[data-course-card]'));
  const coursesPage = courseList.closest('.courses-page');
  const searchForm = coursesPage?.querySelector('[data-course-search-form]');
  const searchInputCourses = coursesPage?.querySelector('[data-course-search]');
  const noResults = courseList.querySelector('[data-course-no-results]');

  function filterCourses() {
    const query = (searchInputCourses?.value || '').trim().toLowerCase();
    let visibleCount = 0;
    courseCards.forEach((card) => {
      const haystack = (card.dataset.courseSearchText || card.textContent || '').toLowerCase();
      const isVisible = !query || haystack.includes(query);
      card.classList.toggle('is-course-filtered', !isVisible);
      if (isVisible) visibleCount += 1;
    });
    if (noResults) noResults.hidden = visibleCount > 0;
    if (!query) noResults?.setAttribute('hidden', '');
    clearCourseBackground();
  }

  function setCourseBackground(card) {
    const image = card?.dataset.courseBg;
    if (!image) return;
    courseList.style.setProperty('--courses-hover-image', `url("${image}")`);
    courseList.classList.add('is-course-hovered');
  }

  function clearCourseBackground() {
    courseList.classList.remove('is-course-hovered');
  }

  courseCards.forEach((card) => {
    card.addEventListener('mouseenter', () => setCourseBackground(card));
    card.addEventListener('focusin', () => setCourseBackground(card));
    card.addEventListener('mouseleave', clearCourseBackground);
    card.addEventListener('focusout', (event) => {
      if (!card.contains(event.relatedTarget)) clearCourseBackground();
    });
  });

  searchInputCourses?.addEventListener('input', filterCourses);
  searchForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    filterCourses();
  });
});

document.querySelectorAll('[data-class-recommendations]').forEach((recommendations) => {
  const cards = Array.from(recommendations.querySelectorAll('[data-class-recommendation-card]'));
  const rail = recommendations.querySelector('.class-recommendations__rail');
  const heading = recommendations.querySelector('.class-recommendations__head h2');
  const returnLink = recommendations.closest('.class-afterword')?.querySelector('.class-return a');
  let isHoveringRecommendation = false;

  function syncRecommendationBackgroundBounds() {
    if (!heading || !returnLink) return;
    const baseRect = recommendations.getBoundingClientRect();
    const headingRect = heading.getBoundingClientRect();
    const returnRect = returnLink.getBoundingClientRect();
    const top = Math.max(0, headingRect.top - baseRect.top - 15);
    const bottom = Math.max(top + 1, returnRect.top - baseRect.top - 15);

    recommendations.style.setProperty('--class-recommendation-bg-top', `${top}px`);
    recommendations.style.setProperty('--class-recommendation-bg-height', `${bottom - top}px`);
  }

  function setRecommendationBackground(card) {
    const image = card?.dataset.recommendationBg;
    if (!image) return;
    syncRecommendationBackgroundBounds();
    recommendations.style.setProperty('--class-recommendation-bg', `url("${image}")`);
    recommendations.classList.add('is-recommendation-hovered');
  }

  function getLeftmostVisibleCard() {
    if (!rail || !cards.length) return cards[0];
    const railRect = rail.getBoundingClientRect();
    const visibleCards = cards
      .map((card) => ({ card, rect: card.getBoundingClientRect() }))
      .filter(({ rect }) => rect.right > railRect.left && rect.left < railRect.right)
      .sort((a, b) => Math.abs(a.rect.left - railRect.left) - Math.abs(b.rect.left - railRect.left));
    return visibleCards[0]?.card || cards[0];
  }

  function setDefaultRecommendationBackground() {
    if (isHoveringRecommendation) return;
    setRecommendationBackground(getLeftmostVisibleCard());
  }

  cards.forEach((card) => {
    card.addEventListener('mouseenter', () => {
      isHoveringRecommendation = true;
      setRecommendationBackground(card);
    });
    card.addEventListener('focusin', () => {
      isHoveringRecommendation = true;
      setRecommendationBackground(card);
    });
    card.addEventListener('mouseleave', () => {
      isHoveringRecommendation = false;
      setDefaultRecommendationBackground();
    });
    card.addEventListener('focusout', (event) => {
      if (!card.contains(event.relatedTarget)) {
        isHoveringRecommendation = false;
        setDefaultRecommendationBackground();
      }
    });
  });

  setDefaultRecommendationBackground();
  syncRecommendationBackgroundBounds();
  window.addEventListener('resize', () => {
    syncRecommendationBackgroundBounds();
    setDefaultRecommendationBackground();
  });
  window.addEventListener('scroll', setDefaultRecommendationBackground, { passive: true });
  window.setInterval(() => {
    syncRecommendationBackgroundBounds();
    setDefaultRecommendationBackground();
  }, 500);
});

document.querySelectorAll('.class-series__list').forEach((seriesList) => {
  const mobileSeriesMedia = window.matchMedia('(max-width: 749px)');
  const items = Array.from(seriesList.querySelectorAll('.class-course-item'));

  function syncMobileSeries() {
    if (!mobileSeriesMedia.matches || !items.length) return;
    items.forEach((item, index) => {
      item.open = index === 0;
    });
  }

  items.forEach((item) => {
    const summary = item.querySelector('summary');
    summary?.addEventListener('click', () => {
      if (!mobileSeriesMedia.matches) return;
      const willOpen = !item.open;
      window.requestAnimationFrame(() => {
        items.forEach((otherItem) => {
          otherItem.open = otherItem === item ? willOpen : false;
        });
      });
    });
  });

  syncMobileSeries();
  mobileSeriesMedia.addEventListener?.('change', syncMobileSeries);
});

document.querySelectorAll('.learning-class-cart__form').forEach((form) => {
  const checkoutTrigger = form.querySelector('[data-class-cart-checkout]');
  checkoutTrigger?.addEventListener('click', async (event) => {
    event.preventDefault();
    const checkoutUrl = checkoutTrigger.dataset.checkoutUrl || '/checkout';
    const action = form.getAttribute('action') || '/cart';
    const updateUrl = `${action.replace(/\/$/, '')}/update.js`;

    try {
      await fetch(updateUrl, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      });
    } catch (error) {
      // Continue to checkout even if the preview server cannot process cart AJAX.
    }

    window.location.href = checkoutUrl;
  });
});

document.querySelectorAll('[data-class-slider]').forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll('[data-class-slide]'));
  const dots = Array.from(slider.querySelectorAll('[data-class-slide-dot]'));
  if (!slides.length || !dots.length) return;

  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  let isPaused = false;

  function setSlide(index) {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === activeIndex);
      slide.style.setProperty('--slide-offset', String(slideIndex - activeIndex));
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === activeIndex);
      dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      setSlide(Number(dot.dataset.slideIndex || 0));
    });
  });

  slider.addEventListener('mouseenter', () => {
    isPaused = true;
  });
  slider.addEventListener('mouseleave', () => {
    isPaused = false;
  });
  slider.addEventListener('focusin', () => {
    isPaused = true;
  });
  slider.addEventListener('focusout', () => {
    isPaused = false;
  });

  setSlide(activeIndex);
  if (slides.length > 1) {
    window.setInterval(() => {
      if (!isPaused) setSlide(activeIndex + 1);
    }, 5200);
  }
});

document.querySelectorAll('[data-journal-topic-disclosure]').forEach((details) => {
  const summary = details.querySelector('summary');
  if (!summary) return;

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    const rail = details.closest('.journal-article__rail');
    const railTop = rail?.getBoundingClientRect().top || 0;
    details.open = !details.open;
    window.requestAnimationFrame(() => {
      const nextTop = rail?.getBoundingClientRect().top || 0;
      const delta = nextTop - railTop;
      if (Math.abs(delta) > 1) window.scrollBy(0, delta);
    });
  });
});

document.querySelectorAll('[data-contact-method-picker]').forEach((picker) => {
  const trigger = picker.querySelector('[data-contact-method-trigger]');
  const current = picker.querySelector('[data-contact-method-current]');
  const input = picker.querySelector('[data-contact-method-value-source]');
  const detailInput = picker.closest('.contact-hba__method-field')?.querySelector('[data-contact-method-value]');
  const form = picker.closest('form');
  const options = Array.from(picker.querySelectorAll('[data-contact-method-option]'));
  if (!trigger || !current || !input || !options.length) return;

  function closePicker() {
    picker.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function openPicker() {
    picker.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  trigger.addEventListener('click', () => {
    if (picker.classList.contains('is-open')) {
      closePicker();
    } else {
      openPicker();
    }
  });

  options.forEach((option) => {
    option.addEventListener('click', () => {
      input.value = option.value;
      current.textContent = option.textContent.trim();
      if (detailInput) {
        detailInput.disabled = false;
        detailInput.required = true;
        detailInput.placeholder = '填寫帳號或號碼';
        detailInput.setCustomValidity('');
        detailInput.focus();
      }
      options.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
      closePicker();
    });
  });

  detailInput?.addEventListener('input', () => {
    if (detailInput.value.trim() && !input.value) {
      detailInput.setCustomValidity('請先選擇聯絡方式');
    } else {
      detailInput.setCustomValidity('');
    }
  });

  form?.addEventListener('submit', (event) => {
    if (!detailInput || !detailInput.value.trim() || input.value) return;
    detailInput.setCustomValidity('請先選擇聯絡方式');
    detailInput.reportValidity();
    event.preventDefault();
  });

  document.addEventListener('click', (event) => {
    if (!picker.contains(event.target)) closePicker();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePicker();
  });
});

document.querySelectorAll('.contact-hba').forEach((contactSection) => {
  const openButton = contactSection.querySelector('[data-contact-mobile-open]');
  const closeButton = contactSection.querySelector('[data-contact-mobile-close]');
  const panel = contactSection.querySelector('[data-contact-mobile-panel]');
  const mobileMedia = window.matchMedia('(max-width: 989px)');
  let closeTimer;
  if (!panel) return;

  function openPanel() {
    window.clearTimeout(closeTimer);
    contactSection.classList.add('is-mobile-form-open');
    document.documentElement.classList.add('is-contact-form-open');
    document.body.classList.add('is-contact-form-open');
    panel.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => {
      panel.querySelector('input:not([type="hidden"]), textarea, button')?.focus();
    });
  }

  function closePanel() {
    contactSection.classList.remove('is-mobile-form-open');
    panel.setAttribute('aria-hidden', 'true');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      document.documentElement.classList.remove('is-contact-form-open');
      document.body.classList.remove('is-contact-form-open');
      openButton?.focus();
    }, 560);
  }

  openButton?.addEventListener('click', openPanel);
  closeButton?.addEventListener('click', closePanel);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-contact-mobile-close]')) return;
    closePanel();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (contactSection.classList.contains('is-mobile-form-open')) closePanel();
  });

  function syncPanelAccessibility() {
    if (mobileMedia.matches && !contactSection.classList.contains('is-mobile-form-open')) {
      panel.setAttribute('aria-hidden', 'true');
    } else {
      panel.removeAttribute('aria-hidden');
    }
  }

  syncPanelAccessibility();
  mobileMedia.addEventListener?.('change', syncPanelAccessibility);
});

document.querySelectorAll('[data-about-difference-slider]').forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll('[data-about-difference-slide]'));
  const controls = Array.from(slider.querySelectorAll('[data-about-difference-slide-control]'));
  if (slides.length < 2) return;

  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  let timer = null;

  function setSlide(index, restart = true) {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === activeIndex);
      slide.style.setProperty('--slide-offset', String(slideIndex - activeIndex));
    });
    controls.forEach((control, controlIndex) => {
      const isActive = controlIndex === activeIndex;
      control.classList.toggle('is-active', isActive);
      control.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
    slider.dispatchEvent(new CustomEvent('aboutDifferenceSlideChange', {
      bubbles: true,
      detail: { index: activeIndex }
    }));

    if (restart) queueSlide();
  }

  function queueSlide() {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => setSlide(activeIndex + 1), 8400);
  }

  controls.forEach((control, controlIndex) => {
    control.addEventListener('click', () => setSlide(controlIndex));
  });

  setSlide(activeIndex, false);
  queueSlide();
});

document.querySelectorAll('[data-about-difference]').forEach((section) => {
  const mobileControls = Array.from(section.querySelectorAll('[data-about-difference-mobile-controls] button'));
  const sliders = Array.from(section.querySelectorAll('[data-about-difference-slider]'));
  if (!mobileControls.length || !sliders.length) return;

  function setMobileControl(index) {
    mobileControls.forEach((control, controlIndex) => {
      const isActive = controlIndex === index;
      control.classList.toggle('is-active', isActive);
      control.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  mobileControls.forEach((control) => {
    control.addEventListener('click', () => {
      const index = Number(control.dataset.slideIndex || 0);
      sliders.forEach((slider) => {
        slider.querySelector(`[data-about-difference-slide-control][data-slide-index="${index}"]`)?.click();
      });
      setMobileControl(index);
    });
  });

  section.addEventListener('aboutDifferenceSlideChange', (event) => {
    setMobileControl(event.detail?.index || 0);
  });

  const track = section.querySelector('.about-difference__track');
  let swipeStartX = 0;
  let swipeStartY = 0;
  let swipePointerId = null;

  function currentMobileIndex() {
    const active = mobileControls.find((control) => control.classList.contains('is-active'));
    return Math.max(0, mobileControls.indexOf(active));
  }

  function setAllSlides(index) {
    const normalizedIndex = (index + mobileControls.length) % mobileControls.length;
    sliders.forEach((slider) => {
      slider.querySelector(`[data-about-difference-slide-control][data-slide-index="${normalizedIndex}"]`)?.click();
    });
    setMobileControl(normalizedIndex);
  }

  track?.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' || event.target.closest('a, button')) return;
    swipePointerId = event.pointerId;
    swipeStartX = event.clientX;
    swipeStartY = event.clientY;
  });

  track?.addEventListener('pointerup', (event) => {
    if (swipePointerId !== event.pointerId) return;
    const deltaX = event.clientX - swipeStartX;
    const deltaY = event.clientY - swipeStartY;
    swipePointerId = null;
    if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
    setAllSlides(currentMobileIndex() + (deltaX < 0 ? 1 : -1));
  });

  track?.addEventListener('pointercancel', () => {
    swipePointerId = null;
  });
});
